import React, { useState, useEffect, useContext } from "react";
import { serverInfo } from "../../../../../../../App";
import noImage from "../../../../../../../assets/Icon/Nodata.png";
import ReactPaginate from "react-paginate";
import axios from "axios";

import LiveIcon from "../../../../../../../assets/images/Souvenir/live.png";
import { Table } from "react-bootstrap";
import Nodata from "../../../../../../Reuseable/Nodata";
import { Link } from "react-router-dom";

const ProductCard = (props) => {
  const { imageCdnUrl } = useContext(serverInfo);
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 8;
  const { data, noBidder, unsold } = props;

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, data]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  const [bidders, setBidder] = useState([]);
  const [totalBidder, setTotalBidder] = useState("");

  const bidderList = (id) => {
    axios.get(`/api/admin/allBidderList/auction/${id}`).then((res) => {
      if (res.data.status === 200) {
        setBidder(res.data.bidderList);
        setTotalBidder(res.data.totalBidder);
      }
    });
  };

  return (
    <>
      {currentItems.length === 0 ? (
        <Nodata />
      ) : (
        <div className="row">
          {currentItems.map((liveProduct, index) => {
            return (
              <>
                <div className="col-sm-6 col-md-4 col-lg-3 mb-3">
                  <div className="card card-bg p-2">
                    <Link
                      to={
                        unsold === "true"
                          ? `/superstar-admin/product/details/${liveProduct.id}`
                          : `/superstar-admin/live-bidding/${liveProduct.id}`
                      }
                      className="Link card card-bg"
                    >
                      <img
                        src={
                          liveProduct
                            ? imageCdnUrl + liveProduct.product_image
                            : noImage
                        }
                        alt=""
                      />
                      <p className="title-limit product-title pt-2">
                        {" "}
                        {liveProduct.title}
                      </p>
                    </Link>

                    {noBidder === "true" ? null : (
                      <button
                        title="Press and show bidders bottom page"
                        className="btn btnViewBidder fw-bold"
                        onClick={() => bidderList(liveProduct.id)}
                      >
                        <i className="fa fa-eye"></i> View Bidders
                      </button>
                    )}
                   {!props?.showOrderstatus ? null : (
                      <Link
                        title="Press and show bidders bottom page"
                        className="btn btnViewBidder fw-bold"
                        to={liveProduct?.has_winner ? `/superstar-admin/auction/product-list/sold/${liveProduct.id}` : `/superstar-admin/product/details/${liveProduct.id}`}
                      >
                        {liveProduct?.has_winner ? (
                          <span><i className="fa fa-check"></i> Process order</span>
                        ) : (
                          <span><i className="fa fa-trophy"></i> Make winner</span>
                        )}
                      </Link>
                    )}
                  </div>
                </div>
              </>
            );
          })}
        </div>
      )}

      <div id="react-paginate" className="mt-3">
        <ReactPaginate
          breakLabel="..."
          nextLabel="next >"
          onPageChange={handlePageClick}
          pageRangeDisplayed={3}
          pageCount={pageCount}
          previousLabel="< previous"
          renderOnZeroPageCount={null}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageLinkClassName={"page-link"}
          previousLinkClassName={"page-link"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
        />
      </div>

      {bidders && bidders.length > 0 ? (
        <div className="row mx-3">
          <div className="d-flex mb-4 mt-5">
            <div className=" d-flex">
              <img src={LiveIcon} className=" SouvenirIcon" alt="" />
            </div>

            <div className=" d-flex text-light fw-bold mt-1 mx-3 ">
              Total Bidder - {totalBidder}
            </div>
          </div>
          <Table striped bordered hover variant="dark">
            <thead>
              <tr>
                <th>#SL</th>
                <th>Name</th>
                <th>Amount</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {bidders &&
                bidders?.map((userInfo, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>
                      {userInfo.user.first_name} {userInfo.user.last_name}
                    </td>
                    <td>{userInfo.amount}</td>
                    <td>
                      {userInfo.applied_status === 1
                        ? "Applied"
                        : "Not Applied"}
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>
      ) : null}
    </>
  );
};

export default ProductCard;
